export default {
  name: 'Sri Lanka 2018',
  events: [
    {
      id: '06c0d390-f95b-11e7-8788-9d36ed7b4214',
      name: 'Heathrow Airport',
      lat: 51.4700223,
      lng: -0.4542954999999438,
      start: true,
      depart: '2018-02-04',
      to: [
        {
          departFrom: 'London Heathrow',
          departureDate: '2018-02-04',
          departureTime: '20:40',
          arrivalDate: '2018-02-05',
          arrivalTime: '07:10',
          type: 'flight',
          flightNumber: 'UL504',
          arriveAt: 'Colombo International Airport'
        }
      ]
    },
    {
      name: 'Negombo',
      lat: 7.200796799999999,
      lng: 79.87367540000002,
      arrive: '2018-02-05',
      id: '13268080-f95b-11e7-8788-9d36ed7b4214',
      to: [
        {
          departFrom: 'Negombo',
          departureDate: '2018-02-07',
          departureTime: '09:00',
          arrivalDate: '2018-02-05',
          arrivalTime: '13:00',
          type: 'car',
          arriveAt: 'Wilpattu National Park'
        }
      ],
      itinerary: [
        {
          descr: 'Transfer to hotel',
          date: '2018-02-05'
        },
        {
          descr: 'TBC',
          date: '2018-02-06'
        },
        {
          descr: 'TBC',
          date: '2018-02-07'
        }
      ]
    },
    {
      name: 'Wilpattu National Park',
      lat: 8.303146000000002,
      lng: 80.14465399999995,
      arrive: '2018-02-07',
      id: '29005fc0-f95b-11e7-8788-9d36ed7b4214',
      to: [
        {
          departFrom: 'Wilpattu National Park',
          departureDate: '2018-02-08',
          departureTime: '09:00',
          arrivalDate: '2018-02-08',
          arrivalTime: '13:00',
          type: 'car',
          arriveAt: 'Sigiriya'
        }
      ],
      itinerary: [
        {
          descr: 'Game drive in Wilpattu; Overnight in the leopard tent!',
          date: '2018-02-07'
        },
        {
          descr: 'Early morning game drive; Transfer to Sigiriya',
          date: '2018-02-08'
        }
      ]
    },
    {
      name: 'Cultural Triangle',
      lat: 7.994260199999998,
      lng: 80.73663880000004,
      arrive: '2018-02-08',
      id: '4ab81e50-f95b-11e7-8788-9d36ed7b4214',
      to: [
        {
          departFrom: 'Sigiriya',
          departureDate: '2018-02-12',
          departureTime: '09:00',
          arrivalDate: '2018-02-12',
          arrivalTime: '13:00',
          type: 'car',
          arriveAt: 'Kandy'
        }
      ]
    },
    {
      name: 'Kandy',
      lat: 7.290571500000001,
      lng: 80.63372619999996,
      arrive: '2018-02-12',
      id: '698fc760-f95b-11e7-8788-9d36ed7b4214',
      to: [
        {
          departFrom: 'Kandy',
          departureDate: '2018-02-15',
          departureTime: '09:00',
          arrivalDate: '2018-02-15',
          arrivalTime: '13:00',
          type: 'train',
          arriveAt: 'Nuwara Eliya'
        }
      ],
      itinerary: [
        {
          descr: 'TBC',
          date: '2018-02-12'
        },
        {
          descr: 'TBC',
          date: '2018-02-13'
        },
        {
          descr: 'TBC',
          date: '2018-02-14'
        },
        {
          descr: 'Transfer to Nuwara Eliya',
          date: '2018-02-15'
        }
      ]
    },
    {
      name: 'Nuwara Eliya',
      lat: 6.949716599999999,
      lng: 80.78910680000001,
      arrive: '2018-02-15',
      id: '8727eb90-f95b-11e7-8788-9d36ed7b4214',
      to: [
        {
          departFrom: 'Nuwara Eliya',
          departureDate: '2018-02-17',
          departureTime: '09:00',
          arrivalDate: '2018-02-17',
          arrivalTime: '13:00',
          type: 'car',
          arriveAt: 'Udawalawe National Park'
        }
      ],
      itinerary: [
        {
          descr: 'Hill country train ride from Kandy to Nuwara Eliya (unconfirmed); Dinner on arrival; Midnight climb of Adam\'s Peak to catch the sunrise',
          date: '2018-02-15'
        },
        {
          descr: 'Return from the mountain and feast; Sleep!',
          date: '2018-02-16'
        },
        {
          descr: 'Transfer to Uda Walawe',
          date: '2018-02-17'
        }
      ]
    },
    {
      name: 'Udawalawe National Park',
      lat: 6.4738889,
      lng: 80.89861109999993,
      arrive: '2018-02-17',
      id: 'a679a6a0-f95b-11e7-8788-9d36ed7b4214',
      to: [
        {
          departFrom: 'Udawalae',
          departureDate: '2018-02-18',
          departureTime: '09:00',
          arrivalDate: '2018-02-18',
          arrivalTime: '13:00',
          type: 'car',
          arriveAt: 'Tangalle'
        }
      ],
      itinerary: [
        {
          descr: 'Afternoon game drive',
          date: '2018-02-17'
        },
        {
          descr: 'Visit the Elephant Transit Home on way to Tangalle',
          date: '2018-02-18'
        }
      ]
    },
    {
      name: 'Tangalle',
      lat: 6.0243383,
      lng: 80.79407259999994,
      arrive: '2018-02-18',
      id: 'b388b2f0-f95b-11e7-8788-9d36ed7b4214',
      to: [
        {
          departFrom: 'Tangalle',
          departureDate: '2018-02-21',
          departureTime: '09:00',
          arrivalDate: '2018-02-21',
          arrivalTime: '13:00',
          type: 'car',
          arriveAt: 'Galle'
        }
      ]
    },
    {
      name: 'Galle',
      lat: 6.053518500000001,
      lng: 80.22097729999996,
      arrive: '2018-02-21',
      id: 'c8096ad0-f95b-11e7-8788-9d36ed7b4214',
      to: [
        {
          departFrom: 'Galle',
          departureDate: '2018-02-24',
          departureTime: '09:00',
          arrivalDate: '2018-02-24',
          arrivalTime: '13:00',
          type: 'car',
          arriveAt: 'Bentota'
        }
      ]
    },
    {
      name: 'Bentota',
      lat: 6.4189175,
      lng: 80.00597900000002,
      arrive: '2018-02-24',
      id: 'e3de3420-f95b-11e7-8788-9d36ed7b4214',
      to: [
        {
          departFrom: 'Bentota',
          departureDate: '2018-02-27',
          departureTime: '09:00',
          arrivalDate: '2018-02-27',
          arrivalTime: '13:00',
          type: 'car',
          arriveAt: 'Negombo'
        }
      ]
    },
    {
      name: 'Negombo',
      lat: 7.200796799999999,
      lng: 79.87367540000002,
      arrive: '2018-02-27',
      id: 'ee55a5a0-f95b-11e7-8788-9d36ed7b4214',
      to: [
        {
          type: 'flight',
          departFrom: 'Colombo International Airport',
          terminal: '',
          departureDate: '2018-02-27',
          departureTime: '20:40',
          flightNumber: 'UL503',
          arriveAt: 'London Heathrow',
          arrivalTime: '07:10'
        }
      ]
    },
    {
      id: 'ff55a5a0-e71b-17d7-1231-9d11ed7b4214',
      name: 'Heathrow Airport',
      lat: 51.4700223,
      lng: -0.4542954999999438,
      arrive: '2018-02-28',
      end: true
    }
  ],
  media: {}
}


// WEBPACK FOOTER //
// ./src/temp/sriLankaTripData.js